module.exports = __webpack_public_path__ + "static/Otchetnost_9_mes_2020-82bf780a4592af21059eab64a155d01d.pdf";